import React from "react";
import Removeselection from "../modals/removeselectionModal";

const Removeselectionbutton = ({ reductionType }) => {
  const [isRseletionModalOpen, setisRseletionModalOpen] = React.useState(false);
  const showrSelectionModal = () => {
    setisRseletionModalOpen(true);
  };
  return (
    <>
      <label
        className="large keyword-selected fw-medium text-white v-center h-center cursor-pointer disabled"
        onClick={reductionType === "replace" ? null : showrSelectionModal}
        
      >
        Select Entities
      </label>
      <Removeselection
        isRseletionModalOpen={isRseletionModalOpen}
        setisRseletionModalOpen={setisRseletionModalOpen}
      />
    </>
  );
};

export default Removeselectionbutton;
